module.exports = __webpack_public_path__ + "static/img/project7.9c65ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project7.png
// module id = D/ll
// module chunks = 1